export default "__VITE_ASSET__c1$crEjb__"